import { render, staticRenderFns } from "./EntityOverviewWidgets.vue?vue&type=template&id=612d851f"
import script from "./EntityOverviewWidgets.vue?vue&type=script&lang=js"
export * from "./EntityOverviewWidgets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports